var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AiHead'),_c('el-form',{staticClass:"login",attrs:{"model":_vm.userInfo}},[_c('div',{staticClass:"login__prompt"},[_c('p',{staticStyle:{"font-size":"28px","font-weight":"700","margin":"0"}},[_vm._v("欢迎访问 AIGenAI 平台")]),_c('p',{staticStyle:{"font-size":"16px","margin-bottom":"50px"}},[_vm._v("人人都有专属的AGI")])])]),_c('AiBottomIcp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }